import { ArticleDetailInsert, ArticleDetailDelete, ArticleDetailUpdate, ArticleDetailGetById, ArticleDetailGetList, ArticleDetailGetPageList } from "@/api/articledetail/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    ArticleDetailInsert(context, payload) {
        return new Promise((resolve, reject) => {


            ArticleDetailInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    ArticleDetailUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            ArticleDetailUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    ArticleDetailGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            ArticleDetailGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    ArticleDetailGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            ArticleDetailGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    ArticleDetailGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            ArticleDetailGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}